export class Page {

    pageNumber :number;
    size:number
    totalElements:number
    totalElementsPark:number
}
